<script lang="ts">
	import Image from '$lib/components/content/Image.svelte';
</script>

<div class="flex flex-col gap-2 md:gap-8">
	<h2>Sponsorships</h2>
	<hr />
	<!-- Main Content -->
	<section class="relative grid gap-2 md:gap-4 grid-cols-1 sm:grid-cols-3">
		<a class="overflow-hidden card card-hover" href="/sponsorships/podcast">
			<header>
				<Image
					src="https://media.codingcat.dev/image/upload/v1686699444/main-codingcatdev-photo/podcast-sponsorship.png"
					alt="Podcast Sponsorship"
				/>
			</header>
			<div class="p-4 space-y-4">
				<h3 data-toc-ignore="">Podcast Sponsorship</h3>
				<article>
					<p>
						Become an exclusive sponsor for a single episode, or multiple podcasts. Includes both
						video and audio within the show.
					</p>
				</article>
			</div>
		</a>
		<a class="overflow-hidden card card-hover" href="/sponsorships/code-with-codingcatdev">
			<header>
				<Image
					src="https://media.codingcat.dev/image/upload/v1686702324/main-codingcatdev-photo/code-with-ccd-sponsorship.png"
					alt="Podcast Sponsorship"
				/>
			</header>
			<div class="p-4 space-y-4">
				<h3 data-toc-ignore="">Code with CodingCat.dev Sponsorship</h3>
				<article>
					<p>
						Looking to showcase your product, live coding helps others to explain how they can see
						your product!
					</p>
				</article>
			</div>
		</a>

		<a class="overflow-hidden card card-hover" href="/sponsorships/blog">
			<header>
				<Image
					src="https://media.codingcat.dev/image/upload/v1686700627/main-codingcatdev-photo/blog-sponsorship.png"
					alt="Blog Sponsorship"
				/>
			</header>
			<div class="p-4 space-y-4">
				<h3 data-toc-ignore="">Blog Sponsorship</h3>
				<article>
					<p>
						Blog sponsorship is a great way to reach a highly engaged audience of potential
						customers.
					</p>
				</article>
			</div>
		</a>
	</section>
</div>
